if(!customElements.get('mm-premium-product')){customElements.define('mm-premium-product',class extends HTMLElement{
connectedCallback(){if(this.initialized){this.gallerySlides?.forEach(slide=>this.galleryObserver?.observe(slide));if(this.galleryStage)this.galleryWidthObserver?.observe(this.galleryStage);if(this.mobileGallery&&this.galleryResize)this.mobileGallery.addEventListener('change',this.galleryResize);return;}this.initialized=true;this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.select=this.querySelector('[data-variant]');const chips=this.querySelector('.mmp-size-buttons');if(chips){chips.hidden=false;this.select.classList.add('mmp-enhanced');this.select.tabIndex=-1;}this.select.addEventListener('change',()=>this.update());this.select.addEventListener('invalid',()=>{this.querySelector('[data-stock]').textContent=this.labels.choose;this.querySelector('[data-variant-id]:not(:disabled)')?.focus();});this.addEventListener('click',e=>{const size=e.target.closest('[data-variant-id]');if(size){this.select.value=size.dataset.variantId;this.select.dispatchEvent(new Event('change',{bubbles:true}));}const thumb=e.target.closest('[data-show-media]');if(thumb)this.showMedia(thumb.dataset.showMedia);const jump=e.target.closest('[data-jump]');if(jump){this.querySelector('.mmp-form').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});this.querySelector('[data-variant-id]:not(:disabled)')?.focus({preventScroll:true});}const detail=e.target.closest('.mmp-service-links a');if(detail){const target=this.querySelector(detail.getAttribute('href'));if(target)target.open=true;}});this.querySelector('form').addEventListener('submit',e=>{if(!this.select.value){e.preventDefault();this.select.reportValidity();}});this.update(false);this.setupSwipe();this.preloadAdjacent();}
setupSwipe(){
  const stage=this.querySelector('.mmp-stage');
  if(!stage)return;
  this.galleryStage=stage;
  this.gallerySlides=Array.from(stage.querySelectorAll('[data-media]'));
  if(this.gallerySlides.length<2)return;
  this.mobileGallery=matchMedia('(max-width: 999px)');
  this.galleryTarget=null;
  stage.classList.add('mmp-swipe-ready');
  const controls=this.querySelector('.mmp-gallery-controls');
  if(controls)controls.hidden=false;
  this.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>this.moveGallery(-1));
  this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>this.moveGallery(1));
  const syncScroll=()=>{
    if(!this.mobileGallery.matches||!stage.clientWidth)return;
    const index=Math.max(0,Math.min(this.gallerySlides.length-1,Math.round(stage.scrollLeft/stage.clientWidth)));
    if(this.galleryTarget!==null){
      if(Math.abs(stage.scrollLeft-this.gallerySlides[this.galleryTarget].offsetLeft)>2)return;
      this.galleryTarget=null;
    }
    if(this.gallerySlides[index].hidden)this.showMedia(this.gallerySlides[index].dataset.media,false);
  };
  stage.addEventListener('scroll',syncScroll,{passive:true});
  stage.addEventListener('pointerdown',()=>{this.galleryTarget=null;},{passive:true});
  stage.addEventListener('touchstart',()=>{this.galleryTarget=null;},{passive:true});
  this.galleryResize=()=>{
    if(!this.mobileGallery.matches){stage.style.removeProperty('height');return;}
    this.galleryTarget=null;
    const active=this.gallerySlides.find(slide=>!slide.hidden)||this.gallerySlides[0];
    stage.scrollTo({left:active.offsetLeft,behavior:'instant'});
    this.fitGalleryHeight();
  };
  this.mobileGallery.addEventListener('change',this.galleryResize);
  this.galleryObserver=new ResizeObserver(()=>this.fitGalleryHeight());
  this.gallerySlides.forEach(slide=>this.galleryObserver.observe(slide));
  this.galleryWidth=stage.clientWidth;
  this.galleryWidthObserver=new ResizeObserver(()=>{
    if(this.galleryWidth!==stage.clientWidth){this.galleryWidth=stage.clientWidth;this.galleryResize();}
  });
  this.galleryWidthObserver.observe(stage);
  this.galleryResize();
  this.updateGalleryControls();
}
moveGallery(direction){
  if(!this.mobileGallery?.matches)return;
  const index=this.gallerySlides.findIndex(slide=>!slide.hidden);
  const next=Math.max(0,Math.min(this.gallerySlides.length-1,index+direction));
  this.showMedia(this.gallerySlides[next].dataset.media);
}
fitGalleryHeight(){
  if(!this.galleryStage||!this.mobileGallery?.matches)return;
  const active=this.gallerySlides.find(slide=>!slide.hidden);
  if(!active)return;
  const height=Math.ceil(active.getBoundingClientRect().height);
  if(height>0&&this.galleryStage.style.height!==height+'px')this.galleryStage.style.height=height+'px';
}
updateGalleryControls(){
  const slides=Array.from(this.querySelectorAll('[data-media]'));
  const index=slides.findIndex(slide=>!slide.hidden);
  const previous=this.querySelector('[data-gallery-prev]');
  const next=this.querySelector('[data-gallery-next]');
  if(previous)previous.disabled=index<=0;
  if(next)next.disabled=index===slides.length-1;
}
disconnectedCallback(){
  this.galleryObserver?.disconnect();
  this.galleryWidthObserver?.disconnect();
  if(this.mobileGallery&&this.galleryResize)this.mobileGallery.removeEventListener('change',this.galleryResize);
}
preloadAdjacent(){
  if(!matchMedia('(max-width: 999px)').matches)return;
  const slides=Array.from(this.querySelectorAll('[data-media]'));
  const current=slides.findIndex(slide=>!slide.hidden);
  [slides[current-1],slides[current+1]].forEach(slide=>{
    const img=slide?.querySelector('img');
    if(img)img.loading='eager';
  });
}
showMedia(id,scroll=true){
  const target=this.querySelector('[data-media="'+id+'"]');
  if(!target)return;
  this.querySelectorAll('[data-media]').forEach(el=>{
    el.hidden=el.dataset.media!==String(id);
    if(el.hidden)el.querySelectorAll('video').forEach(video=>video.pause());
  });
  this.querySelectorAll('[data-show-media]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.showMedia===String(id))));
  this.preloadAdjacent();
  this.updateGalleryControls();
  this.fitGalleryHeight();
  if(scroll&&this.mobileGallery?.matches){
    this.galleryTarget=this.gallerySlides.indexOf(target);
    this.galleryStage.scrollTo({left:target.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
}
update(changeUrl=true){const v=this.variants.find(v=>String(v.id)===this.select.value);this.querySelectorAll('[data-variant-id]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variantId===this.select.value)));if(!v)return;this.querySelector('[data-price]').textContent=v.price;this.querySelector('[data-sticky-price]').textContent=v.price;const compare=this.querySelector('[data-compare]');compare.hidden=!v.compare;compare.textContent=v.compare||'';const stickyCompare=this.querySelector('[data-sticky-compare]');if(stickyCompare){stickyCompare.hidden=!v.compare;stickyCompare.textContent=v.compare||'';}this.querySelector('[data-add]').disabled=!v.available;this.querySelector('[data-stock]').textContent=v.available?this.labels.available:this.labels.soldout;if(v.media)this.showMedia(v.media);if(changeUrl){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}}
});}
